import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";
import { StyledEngineProvider } from "@mui/material/styles";  
import ChangePasswordForm from "./changePasswordForm";
import InvestorChangePasswordForm from "./investor/changePasswordForm";
import { ChangePasswordProps } from "./changePasswordProps";


const ChangePassword: React.FC<ChangePasswordProps> = ({ lang }) => {
  const { i18n } = useTranslation();
 
  useEffect(() => {
    i18n.changeLanguage(lang); 
  }, [lang]); 
  return (
    <StyledEngineProvider injectFirst>
      {lang  ? (
          <InvestorChangePasswordForm />
      ) :( 
        <ChangePasswordForm />
      )} 
    </StyledEngineProvider>
  );
};

export default ChangePassword;
